import React from 'react'

export default function Currency(props) {
    function check(){
        // let currency = JSON.parse([localStorage.getItem('currency')])
        let currency=JSON.parse(localStorage.getItem('currency'))
        // let data=props.acutalData
        switch(document.getElementById('curselect').value){
            case 'INR' : props.setData(props.ad)
            props.symbol('/-')
            localStorage.setItem('symbol', '/-')
            localStorage.setItem('selectedCurrency','INR')
                break;
            case 'eur' : props.setData(props.ad.map(e=>{
                let dat=Object.assign({},e)
                if(props.for=='projects')
                    dat.flyaxavi_approved_coast=parseFloat((dat.flyaxavi_approved_coast/currency['eur']).toFixed(2));
                else if(props.for=='invoices'){
                    dat.Total_rate = parseFloat((dat.Total_rate / currency['eur']).toFixed(2));
                }else{
                    dat.Agree_fee= parseFloat((dat.Agree_fee / currency['eur']).toFixed(2));
                }
                return dat
                }))
                props.symbol('€')
                localStorage.setItem('symbol', '€')
                localStorage.setItem('selectedCurrency','eur')
                break;
            case 'usd' : props.setData(props.ad.map(e=>{
                let dat=Object.assign({},e)
                if(props.for=='projects')
                dat.flyaxavi_approved_coast=parseFloat((dat.flyaxavi_approved_coast/currency['usd']).toFixed(2));
                else if(props.for=='invoices'){
                    dat.Total_rate = parseFloat((dat.Total_rate / currency['usd']).toFixed(2));
                }else{
                    dat.Agree_fee= parseFloat((dat.Agree_fee / currency['eur']).toFixed(2));
                }
                return dat
                }))
                props.symbol('$')
                localStorage.setItem('symbol', '$')
                localStorage.setItem('selectedCurrency','usd')
                break;
            case 'aed' : props.setData(props.ad.map(e=>{
                let dat=Object.assign({},e)
                if(props.for=='projects')
                dat.flyaxavi_approved_coast=parseFloat((dat.flyaxavi_approved_coast/currency['aed']).toFixed(2));
                else if(props.for=='invoices'){
                    dat.Total_rate = parseFloat((dat.Total_rate / currency['aed']).toFixed(2));
                }else{
                    dat.Agree_fee= parseFloat((dat.Agree_fee / currency['eur']).toFixed(2));
                }
                return dat
                }))
                props.symbol('د.إ')
                localStorage.setItem('symbol', 'د.إ')
                localStorage.setItem('selectedCurrency','aed')
                break;
        }
        console.log(props.ad)
    }
    // props.callback.check=check
    
    return (
        <div>
            {/* <div className='showdet filter  currency'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    <div className='projDetI inputfix Projects'>
                        <i onClick={() => {
                            // document.getElementsByClassName('showfil')[0].style.display = 'none' }} 
                            document.getElementsByClassName('currency')[0].classList.remove('show_hide')
                        }}
                            style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                        <table className='currSelTab'>
                            <tr>
                                <td >Select Currency</td>
                                <td>
                                    <select id='curselect'>
                                        <option value='INR'>INR</option>
                                        <option value='eur'>EURO</option>
                                        <option value='usd'>USD</option>
                                        <option value='aed'>AED</option>
                                    </select>
                                </td>
                            </tr>
                        </table>
                        <button className='currShowButt' onClick={() => { check(); document.getElementsByClassName('currency')[0].classList.remove('show_hide') }}> Show Results </button>

                    </div>
                </div>
            </div> */}
        </div>
    )
}
